import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.$slots['title'] ? _renderSlot(_ctx.$slots, "title", {
    key: 0
  }) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "body")], 64);
}